import { FC, useCallback, useState } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import { InputCurrency } from '@/components/ui/InputCurrency';

import { useLingui } from '@lingui/react';
import { debounce } from 'lodash';
import { useFormContext } from 'react-hook-form';

export const HOW_MUCH_REPAIR_COST_NAME = 'how_much_repair_cost';

interface Props {
  name?: string;
}

export const InputHowMuchRepairCost: FC<Props> = ({
  name = HOW_MUCH_REPAIR_COST_NAME,
}) => {
  const { i18n } = useLingui();
  const { control, setValue: setFormValue, trigger, watch } = useFormContext();

  const [localValue, setLocalValue] = useState(
    watch(HOW_MUCH_REPAIR_COST_NAME)
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedUpdateForm = useCallback(
    debounce((newValue) => {
      setFormValue(name, newValue);
      trigger(name);
    }, 500),
    [name, setFormValue]
  );

  const handleChange = (value: string) => {
    setLocalValue(value);
    debouncedUpdateForm(value);
  };

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
        validate: (value) =>
          Number.isNaN(parseFloat(value))
            ? i18n.t('Wartość musi być liczbą.')
            : undefined,
      }}
      render={({ field }) => {
        return (
          <FormItem>
            <FormLabel>{i18n.t('Ile kosztowała naprawa szkody?')}</FormLabel>
            <FormControl>
              <InputCurrency
                label={i18n.t('Kwota')}
                value={localValue}
                onChange={handleChange}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
                className="lg:max-w-[300px]"
                data-testid={`${name}-input`}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};
